import { useRef, useState } from 'react';

export interface SplitterProps {
  orientation: 'vertical' | 'horizontal';
  /** Current size of the panel being resized. */
  size: number;
  onResize(size: number): void;
  /** +1 if dragging right/down grows the panel, -1 otherwise. */
  direction?: 1 | -1;
  min?: number;
  max?: number;
}

export function Splitter({
  orientation,
  size,
  onResize,
  direction = 1,
  min = 120,
  max = 2000,
}: SplitterProps) {
  const start = useRef<{ pos: number; size: number } | null>(null);
  const [dragging, setDragging] = useState(false);
  const axis = orientation === 'vertical' ? 'clientX' : 'clientY';
  return (
    <div
      className={`splitter ${orientation}${dragging ? ' dragging' : ''}`}
      onPointerDown={(e) => {
        (e.target as HTMLElement).setPointerCapture(e.pointerId);
        start.current = { pos: e[axis], size };
        setDragging(true);
      }}
      onPointerMove={(e) => {
        if (!start.current) return;
        const delta = (e[axis] - start.current.pos) * direction;
        onResize(Math.min(max, Math.max(min, start.current.size + delta)));
      }}
      onPointerUp={() => {
        start.current = null;
        setDragging(false);
      }}
    />
  );
}
